var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from "react";

function SvgLaptopAccount(props) {
  return React.createElement("svg", __assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32"
  }, props), React.createElement("g", {
    fill: "currentColor"
  }, React.createElement("path", {
    d: "M26.205 5.051a1.5 1.5 0 011.493 1.356l.007.144-.001 13.709H29a1.5 1.5 0 011.473 1.215l.02.14.007.145v2a1.5 1.5 0 01-1.356 1.493L29 25.26H3a1.5 1.5 0 01-1.493-1.355L1.5 23.76v-2a1.5 1.5 0 011.356-1.493L3 20.26h.749L3.75 6.551a1.5 1.5 0 011.215-1.473l.14-.02.145-.007h20.955zM29 21.261l-8.75-.001v.422a1.5 1.5 0 01-1.355 1.493l-.145.007H13a1.5 1.5 0 01-1.493-1.355l-.007-.145v-.422H3a.5.5 0 00-.492.41l-.008.09v2a.5.5 0 00.41.492l.09.008h26a.5.5 0 00.492-.41l.008-.09v-2a.5.5 0 00-.41-.492L29 21.26zm-9.75-.001H12.5v.422a.5.5 0 00.41.492l.09.008h5.75a.5.5 0 00.492-.41l.008-.09v-.422zm6.955-15.209H5.25a.5.5 0 00-.492.41l-.008.09-.001 13.709h21.955V6.551a.5.5 0 00-.41-.492l-.09-.008z"
  }), React.createElement("path", {
    d: "M14.05 8.25a.7.7 0 01.666.494l.025.102.009.104v8.1a.7.7 0 01-.494.666l-.102.025-.104.009h-3.7a.7.7 0 01-.666-.494l-.026-.106H7.65a.384.384 0 01-.315-.163l-.042-.07-.032-.08-.011-.087v-6c0-.149.082-.282.232-.357l.08-.032.088-.011h2v-1.4c0-.272.156-.51.4-.628l.094-.038.102-.025.104-.009h3.7zm-.1.8h-3.5v1.3h1.4c.149 0 .282.082.357.232l.032.08.011.088v6c0 .05-.01.097-.027.142l-.03.058h1.757v-7.9zm-2.501 2.099h-3.4v5.16l3.4.038v-5.198zm-1.205.301c.203 0 .362.168.362.367 0 .06.04.103.083.104.137 0 .257.078.324.217l.028.075.009.075v2.824c0 .2-.158.367-.36.367-.043 0-.084.044-.084.103a.36.36 0 01-.198.321l-.086.037-.078.01h-.888a.364.364 0 01-.362-.367c0-.06-.04-.103-.083-.104a.355.355 0 01-.324-.217l-.028-.075-.009-.075v-2.824c0-.2.158-.367.36-.367.043 0 .084-.044.084-.103a.36.36 0 01.198-.321l.086-.037.078-.01h.888zm-.276.735h-.334l-.047.087a.837.837 0 01-.301.285l-.014.005v2.271l.083.05a.846.846 0 01.27.317l.006.014h.334l.048-.086a.837.837 0 01.301-.285l.013-.006v-2.271l-.082-.05a.846.846 0 01-.27-.316l-.007-.015zm10.539 2.98a.5.5 0 01.09.991l-.09.009h-3.155a.5.5 0 01-.09-.992l.09-.008h3.155zm3.154-2a.5.5 0 01.09.991l-.09.009h-6.309a.5.5 0 01-.09-.992l.09-.008h6.31zm0-2a.5.5 0 01.09.991l-.09.009h-6.309a.5.5 0 01-.09-.992l.09-.008h6.31z"
  })));
}

export default SvgLaptopAccount;